import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	Voucher,
	VoucherRegistryFilters,
	VoucherRegistryQuery,
	createVoucherRegistryQuery,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

type CreateVoucherRegistryModelParams = {
	$currencies: Store<string[]>;
	$accountId?: Store<number | null>;
	query?: VoucherRegistryQuery;
} & RegistryCallbacks;

export type VoucherRegistryModel = {
	model: RegistryModel<Voucher, VoucherRegistryFilters, JsonApiRequestError>;
	$currencies: Store<string[]>;
};

export const createVoucherRegistryModel = ({
	$accountId,
	$currencies,
	query: queryOverride,
	...params
}: CreateVoucherRegistryModelParams): VoucherRegistryModel => {
	const query = queryOverride ?? createVoucherRegistryQuery($accountId);

	const model = createRegistryModel({
		query,
		page: 0,
		limit: 15,
		filters: {
			currencies: [],
			accountIds: [],
		},
		...params,
	});

	return { model, $currencies };
};
